module.exports = __webpack_public_path__ + "media/SAF-400_Ares_SocialEngineering_2025.331ed986.mp4";